// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__DD6pA","title":"ClientReferral_title__37H_P","itemText":"ClientReferral_itemText__1Ksu1"};